'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_CertificateOfOriginGoodsEntry(description, grossWeight, netWeight, quantity, quantityUnit, unitPrice) {
  this.LE = null;
  this.yX = null;
  this.yY = null;
  this.Fo = null;
  this.Fp = null;
  this.Fq = null;
  this.LE = description;
  this.yX = grossWeight;
  this.yY = netWeight;
  this.Fo = quantity;
  this.Fp = quantityUnit;
  this.Fq = unitPrice;
}
export { $c_Lapp_data_CertificateOfOriginGoodsEntry as $c_Lapp_data_CertificateOfOriginGoodsEntry };
$p = $c_Lapp_data_CertificateOfOriginGoodsEntry.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_CertificateOfOriginGoodsEntry;
/** @constructor */
function $h_Lapp_data_CertificateOfOriginGoodsEntry() {
}
export { $h_Lapp_data_CertificateOfOriginGoodsEntry as $h_Lapp_data_CertificateOfOriginGoodsEntry };
$h_Lapp_data_CertificateOfOriginGoodsEntry.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_CertificateOfOriginGoodsEntry)) {
    if ((this.LE === x$0.LE)) {
      var x = this.yX;
      var x$2 = x$0.yX;
      var $x_3 = ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$3 = this.yY;
      var x$4 = x$0.yY;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.Fo;
      var x$6 = x$0.Fo;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_1 = false;
    }
    if (($x_1 && (this.Fp === x$0.Fp))) {
      var x$7 = this.Fq;
      var x$8 = x$0.Fq;
      return ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 6;
});
$p.t = (function() {
  return "CertificateOfOriginGoodsEntry";
});
$p.e = (function(n) {
  switch (n) {
    case 0: {
      return this.LE;
      break;
    }
    case 1: {
      return this.yX;
      break;
    }
    case 2: {
      return this.yY;
      break;
    }
    case 3: {
      return this.Fo;
      break;
    }
    case 4: {
      return this.Fp;
      break;
    }
    case 5: {
      return this.Fq;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.u = (function(n) {
  switch (n) {
    case 0: {
      return "description";
      break;
    }
    case 1: {
      return "grossWeight";
      break;
    }
    case 2: {
      return "netWeight";
      break;
    }
    case 3: {
      return "quantity";
      break;
    }
    case 4: {
      return "quantityUnit";
      break;
    }
    case 5: {
      return "unitPrice";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.Es = (function() {
  return this.Fo;
});
$p.Kb = (function() {
  return this.Fq;
});
function $isArrayOf_Lapp_data_CertificateOfOriginGoodsEntry(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.je)));
}
export { $isArrayOf_Lapp_data_CertificateOfOriginGoodsEntry as $isArrayOf_Lapp_data_CertificateOfOriginGoodsEntry };
var $d_Lapp_data_CertificateOfOriginGoodsEntry = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_CertificateOfOriginGoodsEntry, "app.data.CertificateOfOriginGoodsEntry", ({
  je: 1,
  jz: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_data_CertificateOfOriginGoodsEntry as $d_Lapp_data_CertificateOfOriginGoodsEntry };
//# sourceMappingURL=app.data.-Certificate-Of-Origin-Goods-Entry.js.map
